import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterBillEditComponent, MasterBillListComponent, MasterBillViewComponent } from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [MasterBillListComponent, MasterBillEditComponent, MasterBillViewComponent],
  imports: [CommonModule, MutualModule, NgxPaginationModule, RouterModule, PipesSharedModule, FormWrapperModule],
  exports: [MasterBillListComponent, MasterBillEditComponent, MasterBillViewComponent],
})
export class MasterBillsModule {}
